import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const MadonnaChildPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  // Additional effect to ensure all links on this specific page get random colors
  useEffect(() => {
    const pageLinks = document.querySelectorAll('a');
    pageLinks.forEach(link => {
      if (!link.dataset.colorApplied) {
        link.style.color = getRandomColor();
        link.dataset.colorApplied = 'true';
      }
    });
  }, []);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/pphRw9FSd67prU6JkSqeeM/Madeleine_Morlet_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/1gohq5pxqgbdPifnTRu3Hx/Madeleine_Morlet_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wek5obGueb1GcANH7YUafd/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/drTSDBgXrqtDrLDduKBUak/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mQK1YS7tgqUw4goGV8EwZb/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/3EiNJ7csTwn3vnnPcbYbQT/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jAwu9NG5rr6bYAeskoA5nc/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/333skG8wqSbHAULsHpcaiW/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qiP4e6FbipCcFgTJHrRGFH/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/w5kp6HN7pXfkqqTcsvZCoi/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ujnPHQWh7o46XC6y7HkLFb/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tJsZDjVvnufuXVBRsMbHyL/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jsjeTMsj8CqUkN854abi2Y/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/njHiaFSahhgXjXS9cqG3Uz/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ko1SnZdewtM3GaNAm7n2VH/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hzSNRiGJ2QH693XQSuiQUe/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/khdUcN2vHciqLHu49wvJdr/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dKoRG3rwrxvWQ44PnjXwjJ/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6e4dubFJYe5yoBtFVCdPu2/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/m1TzRETKqMUauxXyQf8XPH/Madeleine_Morlet_20.jpg'];
  // Create varied spacing and sizing for editorial layout
  const getSpacing = index => {
    const spacings = [8, 14, 10, 16, 12, 18, 9, 15];
    return spacings[index % spacings.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh'; // First image consistent with other pages
    const sizes = ['85vh', '65vh', '75vh', '80vh', '70vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-260" data-mp="17dwkpe7xn11n">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-261" data-mp="12j0qq8j4y3lw">
        <div className="flex space-x-6" data-id="element-262" data-mp="yiqiep7vf13v">
          <div className="text-base font-normal" data-id="element-263" data-mp="tjvrezzr268o">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-264" data-mp="tlqeokyhuafx">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-265" data-mp="2dzgxzekjddxo">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-266" data-mp="29yooqlbnz91e">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-267" data-mp="2c0xs36d41bch">
        <div className="flex min-w-max" data-id="element-268" data-mp="1yac3r24w0977">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-269" data-mp="1y9asawjylkoy">
            <div className="text-base max-w-[360px] pr-4" data-id="element-270" data-mp="1odzag5d97xcz">
              <div data-id="element-271" data-mp="1tc0w8y22eas5">
                Madonna & Child (<em data-id="element-272" data-mp="1td2g9s1267m0">Badlon Magazine</em>, 2025)
              </div>
              <div className="mt-4 text-sm leading-relaxed" data-id="element-273" data-mp="1fchzf1epelv5">
                Talent{' '}
                <a href="https://www.instagram.com/itmilaa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-274" data-mp="1kbcqeqmtrgqc">
                  @itmilaa
                </a>{' '}
                and Baby Blue
                <br data-id="element-275" data-mp="1jmkh93gfodq6" />
                Casting{' '}
                <a href="https://www.instagram.com/annabelcousins" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-276" data-mp="1epu34lo6vs7e">
                  @annabelcousins
                </a>
                <br data-id="element-277" data-mp="v48j3rreb525" />
                Art direction{' '}
                <a href="https://www.instagram.com/mia.theresa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-278" data-mp="100p5ohiy5bd4">
                  @mia.theresa
                </a>
                <br data-id="element-279" data-mp="1nrujys98nvlb" />
                Lighting{' '}
                <a href="https://www.instagram.com/paulperelka" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-280" data-mp="1rt6bx4fl4swo">
                  @paulperelka
                </a>
                <br data-id="element-281" data-mp="3cb8fuyhhj1k0" />
                Digi and Colour Grade Dan Simms
                <br data-id="element-282" data-mp="389wskzm32sez" />
                Hair{' '}
                <a href="https://www.instagram.com/konstantinos_vrettakos" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-283" data-mp="3870tv92evzph">
                  @konstantinos_vrettakos
                </a>
                <br data-id="element-284" data-mp="2fjn1zpdkluc8" />
                Makeup{' '}
                <a href="https://www.instagram.com/maritapolitou" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-285" data-mp="jhb9ioj6gz9s">
                  @maritapolitou
                </a>
                <br data-id="element-286" data-mp="175ulpf5clw75" />
                Stylist{' '}
                <a href="https://www.instagram.com/_mayukawasaki_" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-287" data-mp="shzp3no7z7os">
                  @_mayukawasaki_
                </a>
                <br data-id="element-288" data-mp="35nmrphkkwpfk" />
                Styling Assistants{' '}
                <a href="https://www.instagram.com/yuma_nkhm" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-289" data-mp="3jfup9bjoskfb">
                  @yuma_nkhm
                </a>{' '}
                <a href="https://www.instagram.com/_motoki__" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-290" data-mp="2vpqn78m5csqf">
                  @_motoki__
                </a>
                <br data-id="element-291" data-mp="3hy379clatykg" />
                Studio{' '}
                <a href="https://www.instagram.com/indrastudios" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-292" data-mp="3dxt4e8sszo9t">
                  @indrastudios
                </a>
                <br data-id="element-293" data-mp="x84ck4t9llzs" />
                Thank you Charlotte Brown
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-294" data-mp="2b69twydrqgl1">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-295" data-mp="2g38o1gxfmnj8" data-mpi={index}>
                <img src={image} alt={`Madonna & Child - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-296" data-mp="1s8peehww8ud3" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-297" data-mp="3co0rgyxffcrn">
        <div className="mb-6" data-id="element-298" data-mp="3cpbwt36isskv">
          <div className="text-base mb-4" data-id="element-299" data-mp="3hm2cvqibro6a">
            Madonna & Child (<em data-id="element-300" data-mp="3hkhiq1zxa78y">Badlon Magazine</em>, 2025)
          </div>
          <div className="text-sm leading-relaxed" data-id="element-301" data-mp="1hjb6n68q97ff">
            Talent{' '}
            <a href="https://www.instagram.com/itmilaa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-302" data-mp="1diraa4vza7uc">
              @itmilaa
            </a>{' '}
            and Baby Blue
            <br data-id="element-303" data-mp="1mhcr9vlsxet0" />
            Casting{' '}
            <a href="https://www.instagram.com/annabelcousins" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-304" data-mp="ystf34zmshvn">
              @annabelcousins
            </a>
            <br data-id="element-305" data-mp="13soa9kqfvtmi" />
            Art direction{' '}
            <a href="https://www.instagram.com/mia.theresa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-306" data-mp="13rwdi6l3vpun">
              @mia.theresa
            </a>
            <br data-id="element-307" data-mp="2mrm6848aepbu" />
            Lighting{' '}
            <a href="https://www.instagram.com/paulperelka" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-308" data-mp="2mqkkn5tnakfv">
              @paulperelka
            </a>
            <br data-id="element-309" data-mp="2hrzqno4zkwzv" />
            Digi and Colour Grade Dan Simms
            <br data-id="element-310" data-mp="2hq6k08udicrv" />
            Hair{' '}
            <a href="https://www.instagram.com/konstantinos_vrettakos" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-311" data-mp="35hbzgmwej31n">
              @konstantinos_vrettakos
            </a>
            <br data-id="element-312" data-mp="31g8ke2m6hb1h" />
            Makeup{' '}
            <a href="https://www.instagram.com/maritapolitou" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-313" data-mp="31f78xx192mj8">
              @maritapolitou
            </a>
            <br data-id="element-314" data-mp="25aqeqnjwfz4x" />
            Stylist{' '}
            <a href="https://www.instagram.com/_mayukawasaki_" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-315" data-mp="25bi95v1rfqtm">
              @_mayukawasaki_
            </a>
            <br data-id="element-316" data-mp="1rjlk5zve1x1g" />
            Styling Assistants{' '}
            <a href="https://www.instagram.com/yuma_nkhm" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-317" data-mp="1rl6fhrpj1k0d">
              @yuma_nkhm
            </a>{' '}
            <a href="https://www.instagram.com/_motoki__" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-318" data-mp="2f84sugicobu2">
              @_motoki__
            </a>
            <br data-id="element-319" data-mp="13ro8c8rxv50c" />
            Studio{' '}
            <a href="https://www.instagram.com/indrastudios" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-320" data-mp="yuemf33rdbh9">
              @indrastudios
            </a>
            <br data-id="element-321" data-mp="3feqd3mnnmtwl" />
            Thank you Charlotte Brown
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-322" data-mp="3jhenvzvxiaw7">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-323" data-mp="3oaza6uo5tgfk" data-mpi={index}>
              <img src={image} alt={`Madonna & Child - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-324" data-mp="3t8rd0jqcemyj" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-325" data-mp="72m4e5zffcqc" />
      <style jsx data-id="element-326" data-mp="722iyfaki67k">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default MadonnaChildPage;